import { __rest } from "tslib";
import * as React from "react";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { Input } from "@skve/components"
 *
 * function Demo() {
 *   return <Input type="email" placeholder="Email" />
 * }
 * ```
 */
const Input = React.forwardRef((_a, ref) => {
    var { className, type } = _a, props = __rest(_a, ["className", "type"]);
    return (React.createElement("input", Object.assign({ type: type, className: cn("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className), ref: ref }, props)));
});
Input.displayName = "Input";
export { Input };
//# sourceMappingURL=input.js.map